"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("../../Button/Button"));
require("./AlertBannerButton.scss");
const AlertBannerButton = (_a) => {
    var { marginLeft = false, isDarkBackground = false } = _a, buttonProps = __rest(_a, ["marginLeft", "isDarkBackground"]);
    const overrideButtonProps = Object.assign(Object.assign({}, Button_1.default.defaultProps), buttonProps);
    const classNames = (0, classnames_1.default)({
        "monday-style-alert-banner-button-margin-left": marginLeft,
        "monday-style-alert-banner-button-dark-background": isDarkBackground
    });
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classNames }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({}, overrideButtonProps, { size: Button_1.default.sizes.SMALL, className: "monday-style-alert-banner-button", color: Button_1.default.colors.ON_PRIMARY_COLOR })) })));
};
Object.assign(AlertBannerButton, {
    isAlertBannerItem: true
});
exports.default = AlertBannerButton;
